import { Typography, useTheme } from '@mui/material'
import React from 'react'
const TypographySecondary = ({ text }) => {
  const theme = useTheme()
  return <Typography sx={{ color: theme.palette.text.secondary, fontSize: theme.palette.text.size }}>{text}</Typography>
}

export default TypographySecondary
